export default __webpack_public_path__ + "static/faq-desktop-5f3b7ee9ab079a8488ca9e50220176a1.jpg";